import React, { Component } from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import "./ModalLayout.react.css";


class ModalLayout extends Component {
  constructor(props) {
    super(props);

    this.state = { modalIsOpen: false };
    this.modalIsOpen = false;
  }

  componentDidMount() {
    // Intentar encontrar el elemento de la aplicación
    let appElement = document.getElementById("example") || 
                     document.getElementById("app") || 
                     document.getElementById("root") ||
                     document.body;    
    try {
      Modal.setAppElement(appElement);
    } catch (error) {
      console.warn("No se pudo configurar el elemento de la aplicación para react-modal:", error);
    }
  }

  componentWillUpdate = () => {
    if (this.modalIsOpen === true && this.props.hiddenModal === true) {
      this.setState({ modalIsOpen: false });
      this.modalIsOpen = false;
      if (typeof this.props.Fclose === 'function') {
        this.props.Fclose();
      }
    }
  };
  openModal = () => {
    this.setState({ modalIsOpen: true });
    this.modalIsOpen = true;
  };
  closeModal = () => {
    this.setState({ modalIsOpen: false });
    this.modalIsOpen = false;    
  };
  handleModalCloseRequest = () => {
    this.setState({ modalIsOpen: false });
    this.modalIsOpen = false;
    if (typeof this.props.Fclose === 'function') {
      this.props.Fclose();
    }
  };
  handleSaveClicked = (e) => {
    alert("Save button was clicked");
  };
  render() {
    return (
      <>
        <label className="transparent-input thumbnail" onClick={this.openModal} id={this.props.id}>
          {this.props.name}
        </label>

        {ReactDOM.createPortal(
        <Modal
          closeTimeoutMS={50}
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.handleModalCloseRequest}
          className="Modal"
          overlayClassName="Overlay"
          //appElement={document.getElementById('app')}
          ariaHideApp={false}
          style={{
            overlay: {
              display: this.props.resumirModal ? "none" : "block",
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              zIndex: 9999,
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0
            },
            content: {
              position: "relative",
              top: "60px",
              width: window.screen.width > 900 ? this.props.tamanio : window.screen.width - 20,
              height: "auto",
              margin: "auto",
              zIndex: 10000
            }
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title"> {this.props.title}</h4>
              <div class="btn-group">
                {["Modificar", "Nuevo"].includes(this.props.title) && (
                  <button
                    type="button"
                    className="btn btn-primary fa fa-minus"
                    onClick={this.props.funcionReanudar}
                  />
                )}
                <button
                  type="button"
                  className="btn btn-danger fa fa-close outline pill"
                  onClick={this.handleModalCloseRequest}
                ></button>
              </div>
            </div>
            <div className="modal-body">{this.props.formulario}</div>
            {/**
            <div className="modal-footer">

            </div>
             */}
          </div>
        </Modal>,
          document.getElementById("modal-root") || document.body
        )}
      </>
    );
  }
}

//ReactDOM.render(<ModalLayout/>, appElement);
//ReactDOM.render(<ModalLayout />, document.getElementById("root"));
export default ModalLayout;
